import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import moment from 'moment';
import DetailField from '../common/detail-field';
import ArrowButton from '../common/button-arrow';
import InlineCKEditor from '../common/editor/inline-editor';
import PageTitle from '../common/page-title/index';
import ViewUserDetailsForm from './ppc-user-form';
import { initPersonalRewardsForm } from '../../actions/staff';
import { loadPageContent } from '../../actions/content';

import './styles.css';

class PersonalRewards extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentWillMount() {
    const {dispatch} = this.props;

    dispatch(initPersonalRewardsForm())
      .then(() => {
        const {contentUrl} = this.props;
        if (contentUrl) {
          dispatch(loadPageContent(contentUrl));
        }
      });

  }

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(this.props.contentUrl));
  };

  handleCheckBalance = () => {
    window.open(this.props.managementLink, '_blank');
  };

  renderInlineContent = () => {
    const { contents } = this.props;
    let textIdentifier = null;

    if (Object.keys(contents).length) {
      Object.keys(contents).forEach(curr => {
        if (contents[curr].content_type === 'text') {
          textIdentifier = curr;
        }
      });

      return (
        <div>
          <Row>
            <Col lg={12}>
              <InlineCKEditor identifier={textIdentifier}
                              onContentSaved={this.handleContentSaved}
                              contents={contents[textIdentifier]}/>
            </Col>
          </Row>
        </div>
      );
    } else {
      return '';
    }
  };

  render() {
    let opted_in_content = '';

    if (this.props.personalRewards.attributes['ppc-status'] === 'opted_in') {
      opted_in_content = (
          <Row>
            <Col lg={12} className="ppc-details">
              <ArrowButton submit={false}
                           arrow={false}
                           className="check-balance-btn"
                           onClick={this.handleCheckBalance}>Check my balance</ArrowButton>

              <DetailField label="PPC Opt in Date">
                  {moment(this.props.personalRewards.attributes['created-at']).format("DD-MM-YYYY")}
              </DetailField>
              <DetailField label="PPC Expiry Date">
                  {moment(this.props.personalRewards.attributes['ppc-expire-at']).format("DD-MM-YYYY")}
              </DetailField>
              <br/>
              <DetailField label="Next Load Date">
                  {moment(this.props.personalRewards.attributes['next-load-at']).format("DD-MM-YYYY")}
              </DetailField>
              <DetailField label="Next Load Amount">
                €{this.props.personalRewards.attributes['next-load-amount']}
              </DetailField>
            </Col>
            <Col lg={12}>
              <ViewUserDetailsForm />
            </Col>
          </Row>
      );
    }

    return (
      <Grid fluid className="personal-rewards">
        <Row>
          <Col lg={12}>
            <PageTitle>Personal rewards</PageTitle>
          </Col>
        </Row>
        {this.renderInlineContent()}
        {opted_in_content}
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    personalRewards: state.staff.personalRewards.data,
    managementLink: state.staff.personalRewards.managementLink,
    contentUrl: state.staff.personalRewards.contentUrl,
    contents: state.content.list
  };
};

export default connect(mapStateToProps)(PersonalRewards);



// WEBPACK FOOTER //
// ./src/components/personal-rewards/index.jsx